import * as React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'
import { downloadDocument } from './documentsUtils'

import theme from '@theme/Theme'

interface Props {
  document: RelatedDocument
  name: string
}

const DocumentCard = ({ document, name }: Props) => {
  const i18n = useI18n()
  return (
    <Container key={document.createdAt} activeOpacity={0.9} onPress={() => downloadDocument(document)}>
      <Icon name="document" size={24} color={theme.colors.primary} />
      <DocumentInfos>
        <DocumentDate>{i18n.t(`screens.documents.date`, { date: new Date(document.createdAt) })}</DocumentDate>
        <DocumentName>{name}</DocumentName>
      </DocumentInfos>
      <Icon name="arrow" size={24} color={theme.colors.primary} />
    </Container>
  )
}

export default DocumentCard

const Container = styled(TouchableOpacity)`
  ${(props) => (props.theme.breakpoint === 'phone' ? 'margin-bottom: 8px;' : 'margin: 0px 16px 16px 0px;')}

  padding: ${(props) => (props.theme.breakpoint === 'phone' ? '16px' : '16px 24px')};
  border-radius: 6px;
  background-color: ${(props) => props.theme.colors.background};
  flex-direction: row;
  align-items: center;
  ${(props) => props.theme.constants.shadow};
  ${(props) => props.theme.breakpoint !== 'phone' && `min-width: 360px;`}
`
const DocumentInfos = styled(View)`
  flex: 1;
  padding: 0 16px;
`
const DocumentName = styled(Text)`
  ${(props) => (props.theme.breakpoint === 'phone' ? props.theme.fonts.Body : props.theme.fonts.Headline)};
  ${(props) => props.theme.breakpoint !== 'phone' && `margin-bottom: 8px;`}
`
const DocumentDate = styled(Text)`
  ${(props) => props.theme.fonts.Footnote};
  color: ${(props) => props.theme.colors.secondaryText};
`
